import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TitleService {
  public readonly subtitle$ = new BehaviorSubject<string | undefined>(undefined);
  public readonly showSubtitle$ = new BehaviorSubject(false);
}
